import React, { useState } from "react";
import {
	Button,
	Confirm,
	useMutation,
	useNotify,
	useRefresh,
	useTranslate,
	useUnselectAll,
} from "react-admin";

const ApproveButton = ({ selectedIds }) => {
	const translate = useTranslate();
	const notify = useNotify();
	const refresh = useRefresh();
	const unselectAll = useUnselectAll();
	const [isOpen, setIsOpen] = useState(false);
	const [handleConfirm, { loading }] = useMutation(
		{
			type: "post",
			resource: "user-payments/approve",
			payload: {
				body: {
					selectedIds: selectedIds.filter((v) => typeof v === "number"),
				},
			},
		},
		{
			onSuccess: () => {
				notify(translate("resources.user-payments.messages.approved"));
				unselectAll("user-payments");
				refresh();
				handleClose();
			},
			onError: () => {
				notify(translate("resources.user-payments.messages.approved_fail"));
			},
		}
	);
	const handleClose = () => setIsOpen(false);
	const handleOpen = () => setIsOpen(true);

	return (
		<>
			<Confirm
				isOpen={isOpen}
				loading={loading}
				title={translate("resources.user-payments.titles.approve")}
				content={translate("resources.user-payments.messages.approve")}
				onConfirm={handleConfirm}
				onClose={handleClose}
			/>
			<Button
				onClick={handleOpen}
				label={translate("resources.user-payments.buttons.approve")}
			></Button>
		</>
	);
};

export default ApproveButton;
